<template>
  <div class="bg-[#B2CEE9]">
    <div class="container py-16 md:py-20">
      <div class="flex mb-5">
        <div>
          <h3
            class="font-display text-primary text-2xl md:text-3xl lg:text-[40px] font-semibold mb-4"
          >
            {{ $t("home.happyBoxContents.title") }}
          </h3>
          <p class="text-gray-700 font-thin text-sm md:text-base">
            {{ $t("home.happyBoxContents.text") }}
          </p>
        </div>
      </div>

      <!-- mobile -->
      <div class="md:hidden -mr-5">
        <ClientOnly>
          <swiper-container
            slides-per-view="2.3"
            :space-between="10"
            :breakpoints="{
              768: {
                slidesPerView: 3,
              },
            }"
            :pagination="{
              clickable: true,
            }"
            :autoplay="{
              delay: 8000,
              disableOnInteraction: true,
            }"
          >
            <swiper-slide
              v-for="(content, idx) in happyBoxContents"
              :key="idx"
              class="h-auto mb-12"
            >
              <HomeHappyBoxContentsItem :item="content" />
            </swiper-slide>
          </swiper-container>
        </ClientOnly>
      </div>

      <!-- desktop -->
      <div class="hidden md:flex flex-wrap -mx-2">
        <div
          v-for="content in happyBoxContents"
          class="md:w-1/3 lg:w-1/6 flex px-2 mb-4"
        >
          <div
            class="w-full flex flex-col justify-center items-center rounded-lg bg-white px-5 py-7"
          >
            <img :src="content.image" :alt="content.title" class="w-20" />
            <p
              class="text-gray-800 font-display leading-tight mt-8 text-center"
            >
              {{ content.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup type="tx">
const {t} = useI18n();

const happyBoxContents = [
    {
        image: 'icons/pampers.svg',
        title: t('home.happyBoxContents.contents.pampers'),
    },
     {
        image: 'icons/papers.svg',
        title: t('home.happyBoxContents.contents.papers'),
    },
    {
        image: "icons/bathroom.svg",
        title: t('home.happyBoxContents.contents.bathProducts'),
    },
    {
        image: "icons/socks.svg",
        title: t('home.happyBoxContents.contents.newbornProducts'),
    },
    {
        image: "icons/offers.svg",
        title: t('home.happyBoxContents.contents.offers'),
    },
    {
        image: "icons/plus.svg",
        title: t('home.happyBoxContents.contents.more'),
    },
];
</script>
